﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";


export class GuiDetailEn extends GuiDetailGeneric {
    constructor() {
        super("En");
        $("#btnGotoAktionen").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickGotoAktionen(e));
        $("#VmDetail_SammelNachweis").on("change", () => this.changeSammelnachweis());
        $("#btnCheckEanv").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));

        this.setRequired();

    }

    clickGotoAktionen(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickGotoAktionen");

        // Action ändern für anderen Endpunkt
        const action = $(e.currentTarget).data("action");
        $("#detailForm").attr("action", action);
    }

    changeSammelnachweis() {
        this.log("changeSammelnachweis");
        this.setRequired();
    }

    setRequired() {
        if ($("#VmDetail_SammelNachweis").is(':checked')) {
            $("#VmDetail_BefoerdererId").attr("required", "required");
            $("#VmDetail_BefoerdererId").removeAttr("disabled");
        }
        else {
            $("#VmDetail_BefoerdererId").removeAttr("required");
            $("#VmDetail_BefoerdererId").attr("disabled", "disabled");
        }
    }


    validateClient() {
        //this.createToastValidate("Validierung", "Beförderer muss gewählt werden.", "warning", 5000);
        return true;
    }
}
